"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = require("react-redux");
function usePlayerId() {
    return (0, react_redux_1.useSelector)(function (state) { return state.playerId; });
}
exports.default = usePlayerId;
